export const Config = {
  // LOCAL_URL: "http://localhost:5000",
  // LOCAL_URL: "http://localhost:",
     LOCAL_URL: "https://back.odinesport.com",
};
